import { FormControl, FormControlProps, Input, InputAdornment, InputProps, SxProps } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { ChangeEvent, KeyboardEvent } from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';
import fonts from '../../styles/theme/fonts';
import { colors } from '../../styles/theme/colors';

type SearchFieldProps = {
    handleInputChange: InputProps['onChange'];
    handleOnClickSearch: NonNullable<InputProps['onKeyUp']>;
    handleSearchFieldClear: () => void;
    searchFieldValue: string;
    inputProps?: InputProps;
    formControlSx?: SxProps;
};

export default function SearchField(props: SearchFieldProps) {
    const { handleInputChange, handleOnClickSearch, searchFieldValue, inputProps, formControlSx } = props;
    const { sx, ...restInputProps } = inputProps || {};
    const { t } = useServerTranslation();

    return (
        <>
            <FormControl variant="standard" fullWidth sx={{ maxWidth: '360px', ...formControlSx }}>
                <Input
                    startAdornment={(
                        <InputAdornment position="start">
                            <SearchIcon color="secondary" style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                    )}
                    placeholder={t('menu.search-input-field')}
                    onChange={handleInputChange}
                    onKeyUp={(event: KeyboardEvent<HTMLInputElement>) => {
                        if (event?.currentTarget?.value && event.key === 'Enter') {
                            handleOnClickSearch(event);
                        }
                    }}
                    {...restInputProps}
                    sx={{
                        backgroundColor: colors.secondary1,
                        color: colors.pink2,
                        fontWeight: '600',
                        fontFamily: fonts.button,
                        padding: 1,
                        paddingX: 4,
                        marginX: -4,
                        ...sx,
                    }}
                    value={searchFieldValue}
                    disableUnderline
                />
            </FormControl>
        </>
    );
}
